import script from "./OffCanvasFieldGrowth.vue?vue&type=script&setup=true&lang=js"
export * from "./OffCanvasFieldGrowth.vue?vue&type=script&setup=true&lang=js"

import "./OffCanvasFieldGrowth.vue?vue&type=style&index=0&id=337f158a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-337f158a"]])

export default __exports__